import React, { useState } from 'react';
import styles from '../../assets/scss/WebHomePagesscss/DownloadPopup.module.scss';
import PopupWrapper from '../Common/PopupWrapper';
import { toast } from 'react-toastify';
import { useCreateAppHistoryMutation } from '../../slices/admin/admin';

const DownloadPopup = ({ onClose, onProceed, type }) => {
    const [userInfo, setUserInfo] = useState({ name: '', phone: '' });
    const [errors, setErrors] = useState({ name: '', phone: '' });
    const [createAppHistory, { isLoading }] = useCreateAppHistoryMutation();

    const validate = (name, value) => {
        let error = '';
        if (name === 'name') {
            if (!value.trim()) error = 'Name is required';
        } else if (name === 'phone') {
            if (!value) {
                error = 'Phone number is required';
            } else if (value.length !== 10) {
                error = 'Phone number must be exactly 10 digits';
            } else if (!/^[6-9]/.test(value)) {
                error = 'First digit must be 6, 7, 8, or 9';
            }
        }
        return error;
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        let newValue = value;

        if (name === 'phone') {
            // Only allow digits and max 10 characters
            newValue = value.replace(/\D/g, '').slice(0, 10);
            
            // Real-time restriction for first digit (1-5 not allowed)
            if (newValue.length === 1 && /^[0-5]/.test(newValue)) {
                newValue = '';
            }
        }

        setUserInfo(prev => ({ ...prev, [name]: newValue }));
        setErrors(prev => ({ ...prev, [name]: validate(name, newValue) }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const nameError = validate('name', userInfo.name);
        const phoneError = validate('phone', userInfo.phone);

        if (nameError || phoneError) {
            setErrors({ name: nameError, phone: phoneError });
            return;
        }

        try {
            await createAppHistory({ ...userInfo, type }).unwrap();
            onProceed(userInfo);
        } catch (err) {
            toast.error(err?.data?.message || 'Failed to create history');
        }
    };

    return (
        <PopupWrapper onClose={onClose}>
            <div className={styles.popupContainer}>
                <div className={styles.header}>
                    <h2 className={styles.title}>Download App</h2>
                    <div className={styles.closeIcon} onClick={onClose}>
                        <span>✕</span>
                    </div>
                </div>
                <div className={styles.divider}></div>
                
                <form onSubmit={handleSubmit} className={styles.form}>
                    <div className={styles.fieldGroup}>
                        <label className={styles.label}>Name</label>
                        <input
                            type="text"
                            name="name"
                            className={`${styles.input} ${errors.name ? styles.inputError : ''}`}
                            placeholder="Enter your name"
                            value={userInfo.name}
                            onChange={handleInputChange}
                        />
                        {errors.name && <span className={styles.errorMessage}>{errors.name}</span>}
                    </div>

                    <div className={styles.fieldGroup}>
                        <label className={styles.label}>Phone Number</label>
                        <input
                            type="tel"
                            name="phone"
                            className={`${styles.input} ${errors.phone ? styles.inputError : ''}`}
                            placeholder="Enter 10-digit phone number"
                            value={userInfo.phone}
                            onChange={handleInputChange}
                        />
                        {errors.phone && <span className={styles.errorMessage}>{errors.phone}</span>}
                    </div>

                    <div className={styles.footer}>
                        <button type="button" className={styles.cancelBtn} onClick={onClose}>
                            Cancel
                        </button>
                        <button type="submit" className={styles.submitBtn} disabled={isLoading}>
                            {isLoading ? 'Processing...' : 'Continue'}
                        </button>
                    </div>
                </form>
            </div>
        </PopupWrapper>
    );
};

export default DownloadPopup;
